import { IAggregatedReactionItem, TAggregatedReactions } from "src/types/common";

export const getReactionsCount = (aggregatedReactions: TAggregatedReactions, key: keyof Omit<IAggregatedReactionItem, "reactionType">): number => {
    return aggregatedReactions.reduce((acc, curr) => (acc += curr[key]), 0);
};
